/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=d2168a42"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d2168a42&lang=less"

import exportComponent from "D:\\ww\\mallqr后台+公众号\\mallqr-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__